module.exports = __webpack_public_path__ + "static/media/noun_Apps_914827.e294cd3b.svg";